// tslint:disable-next-line: max-line-length
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  OnDestroy,
  OnInit,
  ViewContainerRef,
  ViewEncapsulation,
  ViewRef,
} from '@angular/core';
import { Router } from '@angular/router';
import { ActionsSubject, Store } from '@ngrx/store';
import { CartTotalsComponent } from '@spartacus/cart/base/components';
import { ActiveCartService, CartActions, StateWithMultiCart } from '@spartacus/cart/base/core';
import { Cart, OrderEntry } from '@spartacus/cart/base/root';
import { CmsService, GlobalMessageService, GlobalMessageType, RoutingService, UserIdService } from '@spartacus/core';
import { BREAKPOINT, BreakpointService } from '@spartacus/storefront';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Observable, Subscription, Unsubscribable } from 'rxjs';
import { filter, map, switchMap, take, tap } from 'rxjs/operators';
import { CUSTOM_LAUNCH_CALLER } from 'src/app/dialog/custom-launch-dialog-config';
import { B2bunitService } from 'src/app/service/b2bunit/b2bunit.service';
import { CartExtendService } from 'src/app/service/cart/cart-extend.service';
import { ComponentService } from 'src/app/service/component.service';
import { ShimanoCountryService } from 'src/app/service/country/shimano-country.service';
import { customDeviceStylings } from 'src/app/service/custom-device-stylings/custom-device-stylings.service';
import {
  GoogleTagManagerEvent,
  GoogleTagManagerService,
} from 'src/app/service/googletagmanager/google-tag-manager.service';
import { ShimanoLanguageService } from 'src/app/service/language/shimano-language.service';
import { StandardModalService } from 'src/app/service/modal/standard-modal.service';
import { PermissionsConstants } from 'src/app/service/myaccount/my-account-permission.constants';
import { MyAccountPermissionService } from 'src/app/service/myaccount/my-account-permission.service';
import { FREIGHT, SHIP_TO_ADDRESS, SnahCountryService } from 'src/app/service/snah/snah-countries.service';
import { StorageService } from 'src/app/service/storage/storage.service';
import { CurrentBusinessType } from 'src/app/utility/current-businesstype';

@Component({
  selector: 'cx-cart-totals',
  templateUrl: './cart-totals.component.html',
  styleUrls: ['./cart-totals.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class ShimanoCartTotalsComponent extends CartTotalsComponent implements OnInit, OnDestroy, AfterViewInit {
  cart$: Observable<Cart>;
  entries$: Observable<OrderEntry[]>;
  pageId: string;
  pagetemplate: string;
  cartPageId = 'CartPageTemplate';
  currentPageHandler: Unsubscribable;
  showSrp = false;
  disableCheckout = false;
  srpSubscription$: Subscription;
  private cartSub = new Subscription();
  cartAddEntrySuccessSubscription$: Subscription;
  isTablet = false;
  breakpointSubscription$: Subscription;

  gtmbusinessType: string = this.currentBusinesstype.getBusinessType();
  affiliation = `/${this.gtmbusinessType}/${this.gtmActiveCountry}/${this.activeLanguage}`;
  appliedVouchers: string;
  totalPrice: any;

  userCurrent$: Observable<string> = this.userIdService.getUserId();

  showActiveSnahCountry$: Observable<boolean> = this.snahCountryService.getSnahFeatures(FREIGHT);
  showSNAHShipToAddress$: Observable<boolean> = this.snahCountryService.getSnahFeatures(SHIP_TO_ADDRESS);

  storeFrontPermissionsSubscription$: Subscription;
  currentAddressSub$: Subscription;
  currentShippingAddress$: any;
  checkoutAllowed: boolean;

  cartValidationComplete = false;
  scartID: string;
  scartAddress: string;
  cartDefaultShippingAddrID: string;

  constructor(
    protected cartService: ActiveCartService,
    protected cms: CmsService,
    private componentService: ComponentService,
    private cdr: ChangeDetectorRef,
    protected cartExtendService: CartExtendService,
    private routing: RoutingService,
    protected router: Router,
    private currentBusinesstype: CurrentBusinessType,
    private countryService: ShimanoCountryService,
    private languageService: ShimanoLanguageService,
    private gtmService: GoogleTagManagerService,
    private actionsSubject: ActionsSubject,
    private breakpointService: BreakpointService,
    private store: Store<StateWithMultiCart>,
    protected b2bUnitService: B2bunitService,
    private userIdService: UserIdService,
    private storageService: StorageService,
    protected modalService: StandardModalService,
    protected el: ElementRef,
    protected vcr: ViewContainerRef,
    private myAccountPermissionService: MyAccountPermissionService,
    private snahCountryService: SnahCountryService,
    private messageService: GlobalMessageService,
    private deviceStylings: customDeviceStylings,
    private deviceService: DeviceDetectorService
  ) {
    super(cartService);
    this.currentPageHandler = this.cms.getCurrentPage().subscribe((str) => {
      if (typeof str !== 'undefined') {
        this.pageId = str.pageId;
        this.pagetemplate = str.template;
      }
    });

    this.cart$ = this.cartService.getActive();
    this.storageService.setLocalStorageitem('onCheckout', 'false');

    // set the address API, ONLY in Cart Page
    if (this.pagetemplate === this.cartPageId) {
      this.currentAddressSub$ = this.showSNAHShipToAddress$.subscribe((isActiveCountrySnah) => {
        if (isActiveCountrySnah) {
          this.currentShippingAddress$ = this.myAccountPermissionService.getShipToAddress();
        } else {
          this.currentShippingAddress$ = this.b2bUnitService.getB2BUnitAddresses();
        }
      });
    }
  }

  get gtmActiveCountry(): string {
    let activeCountry: string;
    this.countryService.getActive().subscribe((country) => (activeCountry = country));
    return activeCountry;
  }

  get activeLanguage(): string {
    let activeLanguage: string;
    this.languageService.getActive().subscribe((lang) => (activeLanguage = lang));
    return activeLanguage;
  }

  ngOnInit() {
    this.entries$ = this.cartService.getEntries().pipe(filter((entries) => entries.length > 0));

    this.getInitSrpToggleValue();
    this.getCheckoutPermission();

    this.srpSubscription$ = this.componentService.srpToggle$.subscribe((checked) => {
      this.showSrp = checked;
      if (!(this.cdr as ViewRef).destroyed) {
        this.cdr.detectChanges();
      }
    });

    this.srpSubscription$ = this.componentService.noStockError$.subscribe((validated) => {
      if (validated) {
        this.disableCheckout = false;
        this.isDisabledCheckout(this.showSrp, validated);
        this.cdr.detectChanges();
      }
    });

    if (this.storageService.getSessionStorageItem('disabledCheckout') !== null) {
      this.disableCheckout = true;
      this.storageService.removeSessionStorageItem('disabledCheckout');
    }
    this.breakpointSubscription$ = this.breakpointService.breakpoint$.subscribe((breakpoint) => {
      this.isTablet = breakpoint === BREAKPOINT.sm || breakpoint === BREAKPOINT.md;
    });
    this.tabletCustomSylings();
  }
  @HostListener('window:resize')
  onResize(): void {
    setTimeout(() => {
      this.tabletCustomSylings();
      this.cdr.detectChanges();
    }, 500);
  }

  tabletCustomSylings() {
    const elCartSummary = document.querySelector('.CenterRightContentSlot');
    const elCheckoutSummary = document.querySelector('.SideContent');
    const elCartPageTemplate = document.querySelector('cx-page-layout.CartPageTemplate');
    if (this.deviceStylings.isTabletMaxWidthExceeds()) {
      elCartSummary?.classList?.add('adjustedStylings');
      elCheckoutSummary?.classList?.add('adjustedStylings');
      elCartPageTemplate?.classList?.add('adjustedStylings');
    } else if (!this.deviceStylings.isTabletMaxWidthExceeds()) {
      elCartSummary?.classList.remove('adjustedStylings');
      elCheckoutSummary?.classList.remove('adjustedStylings');
      elCartPageTemplate?.classList?.remove('adjustedStylings');
    }
  }

  isDisabledCheckout(showSrp: any, validated: any) {
    if (showSrp) {
      return true;
    } else if (!showSrp && !validated && this.disableCheckout) {
      return true;
    } else {
      return false;
    }
  }

  saveCartModal(cart: any = null): void {
    this.modalService.openDialog(CUSTOM_LAUNCH_CALLER.SAVE_CART, this.el, this.vcr)?.pipe(take(1)).subscribe();
  }

  getInitSrpToggleValue() {
    this.showSrp = this.storageService.getLocalStorageItem('showSrp') === 'true';
  }

  onCheckout(code: string, bcartID: string, bcartAddress: string, cart: any = null): void {
    // add rotating class/loader
    document.querySelector('cx-page-layout.CartPageTemplate').classList.add('rotating');
    document.documentElement.style.overflow = 'hidden';

    this.cartSub = this.currentShippingAddress$
      .pipe(
        take(1),
        // get defaultAddress from unitAddress / shipToAddress ONLY
        map((addrs: any) => {
          if (addrs) {
            return addrs.addresses.filter((address: any) => address.defaultAddress === true)[0];
          }
        }),
        // check if has defaultAddress else show error and reload.
        tap((defaultAddress: any) => {
          if (defaultAddress) {
            this.cartDefaultShippingAddrID = defaultAddress?.id;
            this.scartID = defaultAddress?.addressId;
            this.scartAddress = defaultAddress?.formattedAddress;
            this.storageService.setSessionStorageItem('saddID', this.scartID);
            this.storageService.setSessionStorageItem('saddFormatted', this.scartAddress);
            this.storageService.setSessionStorageItem('baddID', bcartID);
            this.storageService.setSessionStorageItem('baddFormatted', bcartAddress);
          } else {
            this.messageService.add({ key: 'cart.genericError' }, GlobalMessageType.MSG_TYPE_ERROR);
            setTimeout(() => {
              location.reload();
            }, 1000);
          }
        }),
        // save delivery address
        switchMap((defaultAddress: any) => this.cartExtendService.saveAddressToCart(defaultAddress.id, code)),
        tap((res: any) => {
          if (res) {
            this.storageService.setSessionStorageItem('saddID', res.deliveryAddress.addressId);
            this.storageService.setSessionStorageItem('saddFormatted', res.deliveryAddress.formattedAddress);
            // reload cart
            this.store.dispatch(
              new CartActions.LoadCart({
                userId: this.userCurrent,
                cartId: res.code,
              })
            );
            this.cart$ = this.cartService.getActive();
            if (!(this.cdr as ViewRef).destroyed) {
              this.cdr.detectChanges();
            }
          }
        }),
        // validation
        switchMap(() => this.cartExtendService.checkCartValidation(code)),
        tap({
          next: (data) => {
            this.storageService.removeSessionStorageItem('defaultCartError');
            this.storageService.removeSessionStorageItem('noStockError');
            this.storageService.removeSessionStorageItem('lowStockError');
            this.storageService.removeSessionStorageItem('disabledCheckout');
            this.storageService.removeSessionStorageItem('unapprovedError');
            this.gtmForCartPage(cart, 'checkout');
            this.routing.go({ cxRoute: 'checkout' });
          },
          error: (error) => {
            const noStocks: any[] = [];
            const lowStocks: any[] = [];
            const unavailable: any[] = [];
            error.error.errors?.forEach((err: any) => {
              if (err.type === 'InsufficientStockError') {
                if (err.reason === 'noStock') {
                  noStocks.push(err.subject);
                } else if (err.reason === 'lowStock') {
                  lowStocks.push(err.subject);
                }
              } else if (err.type === 'CartProcessError') {
                if (err.reason === 'unavailable') {
                  unavailable.push(err.subject);
                }
              } else {
                this.storageService.setSessionStorageItem('defaultCartError', 'true');
              }
            });

            if (noStocks.length > 0 && unavailable.length > 0) {
              this.storageService.setSessionStorageItem('noStockError', JSON.stringify(noStocks));
              this.storageService.setSessionStorageItem('unapprovedError', 'true');
              this.storageService.setSessionStorageItem('disabledCheckout', 'true');
            } else if (noStocks.length > 0 && unavailable.length === 0) {
              this.storageService.setSessionStorageItem('noStockError', JSON.stringify(noStocks));
              this.storageService.setSessionStorageItem('disabledCheckout', 'true');
            } else if (unavailable.length > 0 && noStocks.length === 0) {
              this.storageService.setSessionStorageItem('unapprovedError', 'true');
              this.storageService.setSessionStorageItem('disabledCheckout', 'true');
            } else {
              this.storageService.removeSessionStorageItem('disabledCheckout');
            }

            if (lowStocks.length > 0) {
              this.storageService.setSessionStorageItem('lowStockError', JSON.stringify(lowStocks));
            }

            // this.redirectTo('/cart') <-- TODO for enhancement
            location.reload(); // reload the page so it will get the updated qty
          },
          complete: () => {},
        })
      )
      .subscribe();

    const pendingCarousel = document.getElementsByClassName('cx-pending')[0] as HTMLElement;
    if (pendingCarousel && this.isTablet) {
      document.querySelector('.CartPageTemplate').classList.add('hasPending');
    } else {
      document.querySelector('.CartPageTemplate').classList.remove('hasPending');
    }
  }

  get userCurrent(): string {
    let userCurrent: string;
    this.userCurrent$.pipe(take(1)).subscribe((userId) => (userCurrent = userId));
    return userCurrent;
  }

  redirectTo(uri: any) {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => this.router.navigate([uri]));
  }

  gtmForCartPage(cartDetails: any, event: string): any {
    const productsDataLayer: any[] = [];
    const productsDataLayerForPurchase: any[] = [];
    let index = 0;
    let productPromotions;
    const orderPromotions: any[] = [];
    this.appliedVouchers = cartDetails.appliedVouchers.map((c: any) => c.code).join(' | ');
    this.totalPrice = cartDetails.totalPrice.value;
    cartDetails.entries?.forEach((entry: any) => {
      productPromotions = [];
      if (cartDetails.appliedProductPromotions.length > 0) {
        cartDetails.appliedProductPromotions?.forEach((appliedProductPromotion: any) => {
          appliedProductPromotion.consumedEntries?.forEach((consumedEntry: any) => {
            if (consumedEntry.orderEntryNumber === index) {
              productPromotions.push(appliedProductPromotion.promotion.description);
            }
          });
        });
      }
      if (!productPromotions.length && entry.product.potentialPromotions) {
        entry.product.potentialPromotions?.forEach((potentialPromotion: any) => {
          productPromotions.push(potentialPromotion.description);
        });
        productPromotions.push(entry.promotionMessage);
      }
      if (!productPromotions.length) {
        productPromotions.push(entry.promotionMessage);
      }

      let categories: any = {};
      let totalPriceNoDiscount = 0;
      let discount = 0;
      entry.product.categories?.forEach((cat: any, i: any) => {
        const indexCount = i + 1;
        const label = `item_category${indexCount == 1 ? '' : indexCount}`;
        categories[label] = cat.name;
      });

      totalPriceNoDiscount = entry.basePrice.value * entry.quantity;
      discount = totalPriceNoDiscount - entry.totalPrice.value;

      productsDataLayer.push({
        item_id: entry.product.code,
        item_name: entry.product.name,
        affiliation: this.affiliation,
        coupon: productPromotions.join(' | '),
        discount: discount == 0 ? '0' : discount.toFixed(2),
        item_brand: entry?.product?.brand?.name,
        ...categories,
        price: entry.basePrice.value,
        quantity: entry.quantity,
      });

      productsDataLayerForPurchase.push({
        item_id: entry.product.code,
        item_name: entry.product.name,
        affiliation: this.affiliation,
        coupon: productPromotions.join(' | '),
        discount: discount == 0 ? '0' : discount.toFixed(2),
        item_brand: entry?.product?.brand?.name,
        ...categories,
        price: entry.basePrice.value,
        quantity: entry.quantity,
      });
      index += 1;
    });
    if (cartDetails.appliedOrderPromotions.length > 0) {
      cartDetails.appliedOrderPromotions?.forEach((appliedOrderPromotion: any) => {
        orderPromotions.push(appliedOrderPromotion.promotion.description);
      });
    }
    if (cartDetails.appliedVouchers.length > 0) {
      cartDetails.appliedVouchers?.forEach((appliedVoucher: any) => {
        orderPromotions.push(appliedVoucher.voucherCode);
      });
    }
    const cartDetailsDataLayer = {
      products: productsDataLayer,
      totalItems: cartDetails.totalItems,
      subTotal: cartDetails.subTotal.value,
      totalDiscounts: cartDetails.totalDiscounts.value,
      revenue: cartDetails.totalPrice.value,
      shipping: cartDetails.deliveryCost.value,
      tax: cartDetails.totalTax.value,
    };
    const currencyCode = this.storageService.getSessionStorageItem('currency');

    // CHECKOUT EVENT
    const gtmTagCheckoutStepOne = {
      event: GoogleTagManagerEvent.BEGIN_CHECKOUT,
      ecommerce: {
        currency: currencyCode,
        value: this.totalPrice,
        coupon: orderPromotions.join(' | '),
        items: productsDataLayer,
      },
    };
    const gtmTagForSaveCart = {
      event: 'saveCart',
      ecommerce: {
        currencyCode,
        saveCart: cartDetailsDataLayer,
      },
    };
    const gtmPurchase = {
      event: GoogleTagManagerEvent.PURCHASE,
      ecommerce: {
        transaction_id: cartDetails.code,
        value: this.totalPrice,
        tax: cartDetails.totalTax.value,
        shipping: cartDetails.deliveryCost.value,
        currency: currencyCode,
        coupon: orderPromotions.join(' | '),
        items: productsDataLayerForPurchase,
      },
    };

    if (event === 'checkout') {
      this.gtmService.pushTag({
        ecommerce: null,
        search_term: '',
        results_page: '',
        affiliation: '',
        content_type: '',
        content_id: '',
        content_name: '',
      });
      this.gtmService.pushTag(gtmTagCheckoutStepOne);
      this.storageService.setSessionStorageItem('gtmPurchase', JSON.stringify(gtmPurchase));
      return;
    } else {
      return gtmTagForSaveCart.ecommerce.saveCart;
    }
  }

  getCheckoutPermission(): void {
    this.storeFrontPermissionsSubscription$ = this.myAccountPermissionService.currentUserPermissions$.subscribe(
      (permissions) => {
        this.checkoutAllowed = permissions ? permissions.includes(PermissionsConstants.PLACE_ORDERS) : true;
        this.cdr.detectChanges();
      }
    );
  }

  snahBordersDisplay(isSnahCountry: boolean): string {
    let freightPrice = '$0';
    let freightStatus = false;
    this.componentService.freightLevel$.subscribe((data) => {
      freightPrice = data;
    });
    this.componentService.hasFreeFreight$.subscribe((data) => {
      freightStatus = data;
    });
    if (isSnahCountry && freightPrice && freightPrice !== '$0' && freightStatus) {
      return 'snah';
    } else {
      return '';
    }
  }

  ngAfterViewInit() {}

  ngOnDestroy() {
    this.currentAddressSub$?.unsubscribe();
    this.currentPageHandler?.unsubscribe();
    this.srpSubscription$?.unsubscribe();
    this.breakpointSubscription$?.unsubscribe();
    this.cartSub?.unsubscribe();
    this.storeFrontPermissionsSubscription$?.unsubscribe();
  }
}
